// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"85ceb589","131":"923b533b","145":"6d325fca","253":"dedcf3ae","327":"5166b722","346":"08ee6b88","453":"a0ef5a89","469":"b46d4bad","553":"4d1816aa","590":"2fad4994","598":"6d8d116d","635":"c72867e0","808":"abe9cfd3","854":"ccd5c97f","979":"a83d6e23"}[chunkId] + ".chunk.js";
};